/**
 * sayfa-basligi.tsx
 *
 * NE İŞE YARAR : İçerik alanının başlık satırı — başlık, açıklama ve aksiyonlar
 * KAYNAK SPEC  : 15-arayuz-standardi.md §5.1 (*"içerik: başlık + aksiyonlar + içerik"*)
 *                §13 (erişilebilirlik — başlık sırası) · §4.3 (boşluk)
 * BAĞLI OLDUĞU : @mantine/core
 * KULLANAN     : Kabuğun altındaki bütün ekranlar
 * DİKKAT       : 1) BAŞLIĞI KABUK DEĞİL, EKRAN ÇİZER (`kabuk.tsx` notu 6). Kabuk da
 *                   çizseydi iki başlık kaynağı doğar ve biri diğerini tekrar ederdi.
 *                   Bu bileşen o işi tek biçime bağlar.
 *                2) HER SAYFADA TEK `h1` (`15` §13). Ekran okuyucu sayfanın ne olduğunu
 *                   başlık sırasından anlar; ikinci bir `h1`, sayfanın iki konusu
 *                   olduğunu söyler.
 *                3) AKSİYONLAR SAĞDA VE **İZİN SÜZGECİNDEN ÇAĞIRAN GEÇİRİR**. Bu
 *                   bileşen izne bakmaz: hangi düğmenin görüneceği ekranın kararıdır
 *                   (`15` §7.1). Burada süzülseydi, izin kuralı iki yere dağılırdı.
 * SON GÜNCELLEME: 2026-08-31 04:15:00
 */
import { Box, Group, Stack, Text, Title } from '@mantine/core';
import type { ReactElement, ReactNode } from 'react';

export function SayfaBasligi({
  baslik,
  aciklama,
  aksiyonlar,
}: {
  baslik: string;
  aciklama?: string | undefined;
  aksiyonlar?: ReactNode | undefined;
}): ReactElement {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap" mb="lg" gap="lg">
      <Box style={{ minWidth: 0 }}>
        <Stack gap="xs">
          {/* Başlıktaki not 2 — sayfanın tek `h1`i. */}
          <Title order={1} size="h2">
            {baslik}
          </Title>
          {aciklama === undefined ? null : (
            <Text size="sm" c="notr.7">
              {aciklama}
            </Text>
          )}
        </Stack>
      </Box>

      {aksiyonlar === undefined ? null : <Group gap="sm">{aksiyonlar}</Group>}
    </Group>
  );
}
